import type {
  BetSelection,
  BetslipOverlay,
  SemSelection,
  SingleSelection,
} from "@/features/betslip/types";

export const isSingleSelection = (s: BetSelection): s is SingleSelection =>
  s.kind === "match" || s.kind === "outright" || s.kind === "race";

export const isSemSelection = (s: BetSelection): s is SemSelection =>
  s.kind === "sem";

export const isSemSrm = (s: SemSelection) =>
  s.hub === "racing" || s.marketType?.toLowerCase().includes("race");

// The server is holding the bet - trader review, or a live delay. Either way
// the slip is still in flight, so it reads as placing and blocks edits.
export const isHeldOverlay = (overlay: BetslipOverlay) =>
  overlay.type === "intercepted" || overlay.type === "delayed";
